// extracted by mini-css-extract-plugin
module.exports = {"addressbar":"_0aJ7MV","link":"yhE92M","http":"Xz4e1Y","https":"OTda_u"};